import React, { useState, useEffect, useContext, createContext } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from 'antd';

import { DataContext } from '../../init/getData';
import { PosCartContext } from '../../init/posCartData';

import toast from 'react-hot-toast';

export const selectedMissionContext = createContext();

function KeyPad(props) {

    const { api, input, setInputValue } = props;
    const { tabData, setTabData } = useContext(PosCartContext);

    const [loadingEffect, setLoadingEffect] = useState(false);

    const { settingData } = useContext(DataContext);

    const keys = [
        '1', '2', '3',
        '4', '5', '6',
        '7', '8', '9',
        '.', '0', 'Del',
    ];


    const handleKeyPress = (key) => {
        if (key === 'Del') {
            setInputValue((prev) => prev.slice(0, -1)); // Remove last character
        } else {
            setInputValue((prev) => prev + key); // Append clicked key
        }
    };

    const styles = {
        container: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)', // 3 equal columns
            gap: '10px',
            width: '150px',
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f0f0',
            border: '1px solid #ccc',
            borderRadius: '5px',
            cursor: 'pointer',
            height: '100px',
            fontSize: '18px',
            fontWeight: 'bold',
            userSelect: 'none',
            width: '100px'
        },
    };

    return (
        <div style={styles.container}>
            {keys.map((key, index) => (
                <div
                    key={index}
                    style={styles.button}
                    onClick={() => handleKeyPress(key)}
                >
                    {key}
                </div>
            ))}
        </div>
    );
};




export default KeyPad;
